import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import {PopupmessageTypes} from './popup-types';
import { from } from 'rxjs';
import { PopupIcons } from './popup-icons';

export interface DialogData {
    type:string
    title: string;
    subtitle:string;
    message: string;
    items:string[];
    notificationLevel:number,
    clickRequired:boolean,
    maxDurationSec:number,
    confirmButtonTitle:string,
    dismissButtonTitle:string
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './popupmessage.component.html'
  ,styleUrls: ['./popupmessage.component.scss']
})

export class ConfirmDialogComponent implements OnInit {

    dialogData: DialogData | undefined;
    displayProperties:{iconClass:string,showConfirm:boolean, showLoading:boolean, icon:string}={iconClass:'popup-icon-info',showConfirm:false,showLoading:false, icon:"info",};
    public confirmButtonTitle:string = "Yes"
    public dismissButtonTitle:string = "No"
    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ){}

    ngOnInit() {
        this.setProperties();
    }

    private setProperties(){
        this.dialogRef.disableClose = this.data.clickRequired;

        if(this.data.type === PopupmessageTypes.ok){
            this.displayProperties.showConfirm = false;
            this.setNotificationLevel(this.data.notificationLevel);
        
        }else if(this.data.type === PopupmessageTypes.confirm){
            this.displayProperties.showConfirm = true;
            this.setNotificationLevel(this.data.notificationLevel);
            this.dismissButtonTitle = this.data.dismissButtonTitle;
            this.confirmButtonTitle = this.data.confirmButtonTitle;
        
        }else if(this.data.type === PopupmessageTypes.loading){
            this.displayProperties.showConfirm = false;
            this.displayProperties.showLoading = true;
            this.setNotificationLevel(1);
            if(this.data.maxDurationSec>0){
                setTimeout(
                    ()=>{
                        this.displayProperties.showConfirm = true;
                        this.setNotificationLevel(this.data.notificationLevel);
                    },
                    this.data.maxDurationSec*1000
                );
            }else{
                this.setLoadingErrorTimeout()
            }
        }
    }

    setLoadingErrorTimeout(){
        setTimeout(
            ()=>{
                this.displayProperties.showConfirm = true;
                this.setNotificationLevel(3);
            },
            180*1000 //3 Min
        );
    }

    setNotificationLevel(notifLvl:number){
        // console.log("setting notification level to: "+notifLvl);
        switch (notifLvl){
            case 3://error
                this.displayProperties.iconClass="popup-icon-alert";
                this.displayProperties.icon = PopupIcons.Error;
                break;
            case 2://warning
                this.displayProperties.iconClass="popup-icon-warn";
                this.displayProperties.icon = PopupIcons.Warn;
                break;
            case 0://warning
                this.displayProperties.iconClass="";
                this.displayProperties.icon = "";
                break;
            default://info
                this.displayProperties.iconClass="popup-icon-info";
                this.displayProperties.icon = PopupIcons.Info;
                break;
        }
    }

    onConfirm(): void {
        // Close the dialog, return true
        this.dialogRef.close(true);
    }

    onDismiss(): void {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
}